import { Link } from 'react-router-dom';
import shape1 from "./image/footer-shape-1.png";
import shape2 from "./image/footer-shape-2.png";
import logo from "./image/PranaSrishti.svg";
import partnerLogos from "./image/partner1.png";
function Footer() {
  return (
    <footer class="footer-style-two-with-color p-tb pb">
       <div className="container">
        <div className="row justify-content-center">

          {/* Logo & About */}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="single-footer-widget-card">
              <a className="logo" href="/">
                 <img src={logo} alt="PranaSrishti" width="239" height="40" />
              </a>
              <p>
                At Pranasrishti Solutions, we deliver end-to-end cybersecurity solutions designed to safeguard every part of your digital ecosystem
              </p>
              <ul className="social-links">
                <li><a href="https://www.facebook.com/" target="_blank" rel="noreferrer"><i className="bx bxl-facebook"></i></a></li>
                <li><a href="https://www.instagram.com/" target="_blank" rel="noreferrer"><i className="bx bxl-instagram"></i></a></li>
                <li><a href="https://www.linkedin.com/" target="_blank" rel="noreferrer"><i className="bx bxl-linkedin-square"></i></a></li>
                <li><a href="https://www.twitter.com/" target="_blank" rel="noreferrer"><i className="bx bxl-twitter"></i></a></li>
              </ul>
            </div>
          </div>

          {/* Help Links */}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="single-footer-widget-card">
              <h3>Help</h3>
              <ul className="custom-links">
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Return Policy</a></li>
                <li><a href="#">Terms &amp; Conditions</a></li>
                <li><a href="/about/">About Us</a></li>
                {/* <li><a href='./sample-page'>Sample page</a></li> */}
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="single-footer-widget-card">
              <h3>Contacts</h3>
              <ul className="footer-contact-info">
                <li><span>Address:</span> Delhi, 110053</li>
                <li><span>Email:</span> <a href="mailto:sales@pranasrishti.com">sales@pranasrishti.com </a></li>
                <li><span>Phone:</span> <a href="tel:+91-9266982525">9266982525</a></li>
              </ul>
            </div>
          </div>

          {/* Newsletter */}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="single-footer-widget-card partner-logo">
              <h3>Our Partners</h3>
              <div className="p-logo">
              <a href='/'><img src={partnerLogos} alt="All security certifications" /></a>
               <a href='/'><img src={partnerLogos} alt="All security certifications" /></a>
               </div>
    
            </div>
          </div>

        </div>
      </div>

      {/* Copyright */}
      <div className="copyright-style-two-with-color">
        <div className="container">
          <p>
            Copyright <i className="bx bx-copyright"></i>2025 pranasrishti. Designed By{" "}
            <a href="/" target="blank" rel="noreferrer">pranasrishti</a>
          </p>
          <div className="footer-shape-1">
            <img
              alt="image"
              loading="lazy"
              width="240"
              height="336"
              decoding="async"
              src={shape1}
              style={{ color: "transparent" }}
            />
          </div>
          <div className="footer-shape-2">
            <img
              alt="image"
              loading="lazy"
              width="610"
              height="452"
              decoding="async"
              src={shape2}
              style={{ color: "transparent" }}
            />
          </div>
          <div className="lines-line">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;